module.exports = __webpack_public_path__ + "static/WEDDING E&M-166-d479d09981cec48a67899914518095e2.jpg";